module.exports = __webpack_public_path__ + "img/home-bg4-2.72965d41.png";